const fromDateStamp = (dateStamp: string): Date => {
  return new Date(dateStamp)
}

export default fromDateStamp
